import cache from './cache.js';
import getOperatingSystem from './getOperatingSystem.js';

export default cache('isKindle', function isKindle() {
  return getOperatingSystem().name.indexOf('Amazon OS') > -1;
});